import { BusinessQuickForm } from "@/components/BusinessQuickForm";
import { Coffee, UtensilsCrossed, Fuel, Building2 } from "lucide-react";

const SEGMENTS = [
  { icon: Coffee, label: "Kafeer" },
  { icon: UtensilsCrossed, label: "Restauranter og storkjøkken" },
  { icon: Fuel, label: "Bensinstasjoner" },
  { icon: Building2, label: "Hoteller og kontorer" },
];

const PROBLEMS = [
  ["Maskinen lekker vann", "Kontroll og bytte av pakninger, dusjsiler og o-ringer."],
  ["Svak kaffe eller dårlig gjennomstrømning", "Avkalking og full rengjøring av bryggegruppen."],
  ["Ingen vann eller pumpen jobber ikke", "Feilsøking og reparasjon av pumper og ventiler."],
  ["Feilkoder eller maskinen starter ikke", "Elektronisk feilsøking ned på komponentnivå."],
  ["Feil temperatur eller trykk", "Trykk- og temperaturkalibrering."],
];

export function BusinessInquirySection({ source, title, intro }) {
  return (
    <section className="py-16 md:py-24 bg-[#FFF8F0]" data-testid={`business-section-${source}`}>
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3D2314] mb-4 font-display">{title}</h2>
          <p className="text-[#1A1A1A]/75 mb-6">{intro}</p>
          <div className="grid grid-cols-2 gap-3 mb-8">
            {SEGMENTS.map((s) => (
              <div key={s.label} className="flex items-center gap-2 text-sm text-[#3D2314]"><s.icon className="h-4 w-4 text-[#D4A574] shrink-0" />{s.label}</div>
            ))}
          </div>
          <h3 className="font-semibold text-[#3D2314] mb-3">Vanlige feil vi feilsøker</h3>
          <dl className="space-y-3">
            {PROBLEMS.map(([p, d]) => (
              <div key={p}><dt className="text-sm font-medium text-[#3D2314]">{p}</dt><dd className="text-sm text-[#1A1A1A]/65">{d}</dd></div>
            ))}
          </dl>
          <p className="text-xs text-[#1A1A1A]/55 mt-6">Årsaken fastsettes alltid i diagnostikken. Merkenavnene viser hvilke maskiner vi reparerer og betyr ikke at vi er produsentens autoriserte verksted. Utenfor Bergen bekreftes transportprisen før utreise.</p>
        </div>
        <div className="lg:col-span-3">
          <BusinessQuickForm source={source} />
        </div>
      </div>
    </section>
  );
}
